import { useMemo } from "react";
import {vat} from '../../../_common/constants/financial';

export const useCalculations = (lines: any[] = []) => {
  const VAT_RATE = vat;
  return useMemo(() => {
    let totalNet = 0;
    let totalVat = 0;
    let total = 0;

    const rows = lines.map(line => {
      const qty = Number(line.quantity) || 0;
      const price = Number(line.price) || 0;
      const lineAmount = qty * price;

      let net: number;
      let vat: number;
      let gross: number;

      if (line.vatType?.value === 0) {
        // "לפני מע"מ" — price is NET, VAT added on top
        net   = lineAmount;
        vat   = lineAmount * VAT_RATE;
        gross = lineAmount + vat;

      } else if (line.vatType?.value === 1) {
        // "כולל מע"מ" — price is GROSS, VAT extracted from inside
        gross = lineAmount;
        net   = gross / (1 + VAT_RATE);
        vat   = gross - net;

      } else {
        // No VAT (null / undefined / unknown)
        net   = lineAmount;
        vat   = 0;
        gross = lineAmount;
      }

      totalNet += net;
      totalVat += vat;
      total    += gross;

      return { net, vat, total: gross };
    });

    return { rows, totalNet, totalVat, total };
  }, [lines]);
};